import {
  Component,
  EventEmitter,
  OnInit,
  OnChanges,
  Output,
  Input,
  ViewChild
} from '@angular/core';
import {
  ProgramTypesGUID,
  ProgramTypes
} from '../../../../models/_enum-collections';
import { CommonInputModel } from '../../../../models/common-input.model';
import { EventRegistrationCustomerModel } from '../../../../models/event-registration.model';
import { PartnerPaymentDetails } from '../../../../models/partner-payment-details.model';
import { CommonSharedModule } from '../../../common/shared.module';
import { DashboardService } from '../../../services/dashboard.service';
import { LocalStorageService } from '../../../services/local-storage-service';
import { EventDetailsComponent } from '../event-details/event-details.component';
import { EventDetailsTabComponent } from './event-details-tab/event-details-tab.component';
import { PartnerDetailsComponent } from './partner-details/partner-details.component';
import { OneToOneCustomerDetailsComponent } from './one-to-one-customer-details/one-to-one-customer-details.component';
import { PaymentProfileTabComponent } from './payment-profile-tab/payment-profile-tab.component';
import { EventPaymentInformationComponent } from './event-payment-information/event-payment-information.component';
import { AppEventsMilestone2PaymentInformationComponent } from './event-milestone2-payment-information/event-milestone2-payment-information.component';
import { EventPoeSubmissionComponent } from './event-poe-submission/event-poe-submission.component';
import { EventDashboardService } from '../../../services/event-dashboard.service';
import { EventDashboardApi } from '../../../../api/eventDashboardApi';

@Component({
  selector: 'app-edit-event',
  templateUrl: './edit-event.component.html',
  styleUrls: ['./edit-event.component.scss'],
  standalone: true,
  imports: [
    AppEventsMilestone2PaymentInformationComponent,
    CommonSharedModule,
    EventDetailsComponent,
    EventDetailsTabComponent,
    EventPaymentInformationComponent,
    EventPoeSubmissionComponent,
    PartnerDetailsComponent,
    PaymentProfileTabComponent,
    OneToOneCustomerDetailsComponent
  ]
})
export class EditEventComponent implements OnInit, OnChanges {
  constructor(
    private localStorage: LocalStorageService,
    private eventDashboardApi: EventDashboardApi,
    private dashboardServices: DashboardService,
    private eventDashboardService: EventDashboardService
  ) {}

  isFullScreen!: boolean;
  colorLoader = true;
  isOneToMany = true;
  isMRPPProgram = false;
  profilePaymentDetails!: PartnerPaymentDetails;
  eventRegistrationDetails;
  tabHeader!: string;
  detailsTabHeader!: string;
  @Output() closeEditSidebar = new EventEmitter<boolean>();
  @Output() showFullscreen = new EventEmitter<boolean>();
  @Input() eventRegistrationId!: number;
  @Input() programTypeGUID!: string;
  @ViewChild('eventDetailsHeader', { static: false })
  eventDetailsHeader!: EventDetailsComponent;
  @ViewChild('eventDetailsTab', { static: false })
  eventDetailsTab!: EventDetailsTabComponent;
  eventCustomers: EventRegistrationCustomerModel[] = [];

  ngOnInit() {
    this.isMRPPProgram =
      this.programTypeGUID !== undefined &&
      this.programTypeGUID == ProgramTypesGUID.MRPP;
    this.tabHeader = 'Engagement Payment Information';
    this.detailsTabHeader = 'Engagement Details';
    this.isFullScreen = this.localStorage.getFullscreenMode();

    this.eventDashboardApi
      .getEventCustomers(this.eventRegistrationId)
      .subscribe(dt => {
        this.eventCustomers = dt;
      });
    if (this.isMRPPProgram) {
      this.eventDashboardService
        .getEventRegistration(this.eventRegistrationId)
        .subscribe(data => {
          this.eventRegistrationDetails.fiscalYear = data.fiscalYear;
          this.eventRegistrationDetails.partnerMpnid = data.partnerMpnid;
          this.isOneToMany = data.isOneToMany || false;

          this.getPartnerPaymentDetails();
        });
    }

    setTimeout(() => (this.colorLoader = false), 3000);
  }

  closeSidebar() {
    this.localStorage.setFullscreenMode(this.isFullScreen);
    this.closeEditSidebar.emit(false);
  }

  refreshEventDetails() {
    this.eventDetailsHeader.refreshEvent();
  }

  refreshNotes() {
    this.eventDetailsHeader.refreshNotes();
  }

  refreshEventHeaderAndDetails() {
    this.eventDetailsHeader.refreshEvent();
    this.eventDetailsTab.refreshEventDetailsTab();
  }

  showFullScreen(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
    this.localStorage.setFullscreenMode(this.isFullScreen);
    this.showFullscreen.emit(this.isFullScreen);
  }

  getCustomerDetails(): string {
    return `Customer Details (${this.eventCustomers.length} of 20)`;
  }

  ngOnChanges(): void {
    this.ngOnInit();
  }

  getPartnerPaymentDetails() {
    const mpnId = this.eventRegistrationDetails.partnerMpnid;
    const commonInputModel: CommonInputModel = {
      mpnId: mpnId.toString(),
      programTypeId: ProgramTypes.MRPP,
      year: this.eventRegistrationDetails.fiscalYear.toString()
    } as any;

    this.dashboardServices
      .getPartnerAndPaymentDetails(commonInputModel)
      .subscribe(partnerPaymentDetails => {
        this.profilePaymentDetails = partnerPaymentDetails;
      });
  }
}
